<template>
    <div class="layout__padding-clear">
        <div class="text__align-center text__colour-teal layout__margin__bottom-25px colour__background__grey-f7f8fa">
            <div class="layout__padding-clear layout__padding-20px">
                <div class="text__colour-teal text__size-45 text__style-bold-700">Document Folders</div>
            </div>
        </div>

        <div class="layout__padding-clear layout__width-80">
            <div class="component__columns-2 layout__margin-20-0">
                <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/Docufolders.jpg" class="layout__width-90 layout__padding__bottom-25px">
            </div>
            <div class="component__columns-2 layout__margin-20-0">
                <h3 class="text__colour-teal text__style-bold-900">A smart, professional way to present important documents.</h3>

                <div class="text__size-16 text__colour-grey layout__padding-20-0 text__line-height-20px">
                    Important documents deserve a bold folder that remind your customers of your brand. We recommend a heavyweight, 350gsm card with either a gloss or matt lamination for extra durability.
                </div>

                <div class="text__size-16 text__colour-grey text__line-height-20px">
                    Our in-house design studio can work with you to create a design completely unique to your agency. Why not redesign your company brochure in line with your document folder?
                </div>

                <div class="text__size-16 text__colour-teal text__line-height-20px layout__padding-20-0">
                    Options:
                </div>

                <div class="text__size-16 text__colour-grey text__line-height-20px">
                    Sizes: A4 or A5
                </div>
                <div class="text__size-16 text__colour-grey text__line-height-20px layout__padding-20-0">
                    Finishes: Gloss or Matt lamination
                </div>
                <div class="text__size-16 text__colour-grey text__line-height-20px">
                    Capacity: 0mm for 15 sheets, 3mm for 25 sheets, 5mm for 40 sheets
                </div>


                <div class="layout__padding-20-0">
                    <el-button class="layout__width-230px button-red layout__margin__right-20px" v-on:click="instantPrint()">I've got print ready artwork
                    </el-button>
                    <el-button class="layout__width-200px button-red"
                               v-on:click="contactUs()">I need this designed
                    </el-button>
                </div>
            </div>
        </div>

        <div class="layout__padding-20px colour__background__grey-f7f8fa layout__padding-clear layout__overflow-hidden">
            <div class="text__size-30 text__align-center text__colour-teal text__style-bold-900 layout__padding-20px">
                You may also like
            </div>

            <div class="layout__width-80 layout__padding-clear">

                <router-link class="link__colour-black" to="/products/digital/web-banners">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/web-banner-720x500.png" class="layout__width-100">
                        <div class="component__product__subtitles">
                            <div>Web Banners</div>
                        </div>
                    </div>
                </router-link>

                <router-link class="link__colour-black" to="/products/digital/microsites">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/micrositemockup.jpg" class="layout__width-100">
                        <div class="component__product__subtitles">
                            <div>Microsites</div>
                        </div>
                    </div>
                </router-link>

                <router-link class="link__colour-black" to="/products/digital/animated-brochure">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/animated-brochure-720x500.png" class="layout__width-100">
                        <div class="component__product__subtitles">
                            <div>Animated Brochure</div>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>


    </div>

</template>

<script>

    import Router from '../../router';

    export default {
        name: "documentFolders",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            },
            instantPrint() {
                Router.push({
                    name: '/instant-print'
                });
            }
        }
    };
</script>
